import axios from 'axios';
import { configRefs } from '@utils/constants';

async function getLastLocationRequest(portalConfig, user) {
  const endpoint = await configRefs.apis.userdata.get();
  const res = await axios.get(`${endpoint}/api/ProgressionsV2?userID=${encodeURIComponent(user.id)}&userInstitutionID=${encodeURIComponent(user.institution?.id ?? "")}&productID=${encodeURIComponent(portalConfig.id)}`);
  if (!res.data) {
    return null;
  }
  if (Object.keys(res.data.dynamicContent).length === 0) {
    return {
      descriptor: undefined,
      objectId: res.data.objectID
    };
  }
  return {
    descriptor: res.data.dynamicContent,
    objectId: res.data.objectID
  };
}

export { getLastLocationRequest };
//# sourceMappingURL=get-last-location.request.js.map
